<template>
  <div class="prefecture">
    <div class="main">
      <div class="blue-name">
        <div class="team-name">{{ hotTeamList.blueTeamName }}</div>
        <div class="name-list">
          <div>
            <div class="name-item">替补</div>
            <div class="name-item" v-for="(item, index) in hotTeamList.bluePlayerList.First">{{ item.name }}</div>
          </div>
          <div>
            <div class="name-item">首发</div>
            <div class="name-item" v-for="(item, index) in hotTeamList.bluePlayerList.alternate">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="hot-dot">
        <div class="hot-select">
          <a-checkbox-group @change="handleHot">
            <a-row>
              <a-col :span="6">
                <a-checkbox value="A">
                  Q1
                </a-checkbox>
              </a-col>
              <a-col :span="6">
                <a-checkbox value="B">
                  Q2
                </a-checkbox>
              </a-col>
              <a-col :span="6">
                <a-checkbox value="C">
                  Q3
                </a-checkbox>
              </a-col>
              <a-col :span="6">
                <a-checkbox value="D">
                  Q4
                </a-checkbox>
              </a-col>

            </a-row>
          </a-checkbox-group>
        </div>
        <div class="hot-map"></div>
      </div>
      <div class="red-name">
        <div class="team-name">{{ hotTeamList.redTeamName }}</div>
        <div class="name-list">
          <div>
            <div class="name-item">首发</div>
            <div class="name-item" v-for="(item, index) in hotTeamList.redPlayerList.First">{{ item.name }}</div>
          </div>
          <div>
            <div class="name-item">替补</div>
            <div class="name-item" v-for="(item, index) in hotTeamList.redPlayerList.alternate">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasketballPrefecture',
  props: {},
  data() {
    return {
      hotTeamList: {
        blueTeamName: '蓝方代表队',
        bluePlayerList: {
          First: [
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
          ],
          alternate: [
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
          ],
        },
        redTeamName: '红方代表队',
        redPlayerList: {
          First: [
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
          ],
          alternate: [
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
            {
              name: '球员姓名',
            },
          ],
        },
      },
    }
  },
  components: {},
  mounted() {},
  methods: {
    handleHot(e){
      console.log(e);
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.prefecture {
  width: 100%;
  background-color: #f8f8f8;
  padding-bottom: 30px;
  .main {
    width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    .blue-name {
      .name-list {
        display: flex;
        justify-content: space-between;
        .name-item {
          width: 148px;
          height: 50px;
          line-height: 50px;
          background-color: #dfdfdf;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin-top: 2px;
          cursor: pointer;
        }
      }
      .team-name {
        width: 298px;
        height: 60px;
        line-height: 60px;
        background-color: #ff7815;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
    }
    .hot-dot {
      width: 596px;
      .hot-select {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .hot-map {
        width: 596px;
        height: 325px;
        // background-color: #ebebeb;
        background-image: url('../../../../assets/match/hot-map.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
    .red-name {
      .name-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .name-item {
          width: 148px;
          height: 50px;
          line-height: 50px;
          background-color: #dfdfdf;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin-top: 2px;
          cursor: pointer;
        }
      }
      .team-name {
        width: 298px;
        height: 60px;
        line-height: 60px;
        background-color: #0073d5;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
    }
    .name-item:hover{
      opacity: 0.8;
    }
  }
}
// 鼠标hover时候的颜色
/deep/ .ant-checkbox-wrapper:hover .ant-checkbox-inner,
/deep/ .ant-checkbox:hover .ant-checkbox-inner, 
/deep/ .ant-checkbox-input:focus + .ant-checkbox-inner{
   border: 2px solid #BE1E28 !important;
}
// 设置默认的颜色
/deep/ .ant-checkbox{
  .ant-checkbox-inner{
    border: 2px solid #E4E4E4;
    background-color: transparent;
  }
} 
// 设置选中的颜色
/deep/ .ant-checkbox-checked .ant-checkbox-inner,
.ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #BE1E28;
    border: 2px solid #BE1E28;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballPrefecture.vue